import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { CheckboxGroup, CheckboxGroupProps, Color, Radius, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {},
  text: {
    lineHeight: 16,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  legend: {
    width: 12,
    height: 12,
    borderRadius: Radius.XS,
    marginRight: Spacing.XS,
  },
  average: {
    backgroundColor: Color.greyBlue,
  },
  peak: {
    backgroundColor: Color.calmGrey,
  },
})

export type GraphBar = 'average' | 'peak'

interface Props extends Omit<CheckboxGroupProps<GraphBar>, 'items'> {}

const GraphBarSelect = (props: Props) => {
  const { value = ['average', 'peak'], style, ...otherProps } = props
  const { t } = useTranslation()

  const items = [
    {
      value: 'average',
      title: (
        <View style={styles.option}>
          <View style={[styles.legend, styles.average]} />
          <Text style={styles.text}>{t('Average')}</Text>
        </View>
      ),
    },
    {
      value: 'peak',
      title: (
        <View style={styles.option}>
          <View style={[styles.legend, styles.peak]} />
          <Text style={styles.text}>{t('Peak')}</Text>
        </View>
      ),
    },
  ]

  return <CheckboxGroup items={items} value={value} style={[styles.container, style]} {...otherProps} />
}

export default GraphBarSelect
